<template>
  <el-tabs v-model="activeName" class="tabs">
    <el-tab-pane name="first" label="电脑端" class="mineCon">
      <div class="help">
        <p><strong>第一步：</strong>登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【我的预约】</span>按钮</p>
        <img src="../../../assets/userImg/updateAppoint_a.png" alt="">
        <p><strong>第二步：</strong>在【预约列表】中，点击<span class="orange">【修改申请】</span>按钮，弹出【审批】弹窗</p>
        <img src="../../../assets/userImg/editApplication_a.png" alt="">
        <p><strong>第三步：</strong>在【修改申请】弹窗中，对医生提交的申请进行审批，选择<span class="orange">【同意】</span>或<span
            class="orange">【拒绝】</span>，当选择<span
            class="orange">【拒绝】</span>必须填写拒绝的理由
        </p>
        <img src="../../../assets/userImg/editApplication_b.png" alt="">
      </div>
    </el-tab-pane>
    <el-tab-pane name="second" label="移动端" class="mineCon">
      <div class="help">
        <div class="flex userPh">
          <p><strong>第一步：</strong>在【菜单栏】中点击<span class="orange">【我的预约】</span></p>
          <p><strong>第二步：</strong>点击列表中<span class="orange">【修改申请】</span>按钮</p>
          <p><strong>第三步：</strong>在【修改申请】弹窗中，对医生提交的申请进行审批，选择<span class="orange">【同意】</span>或<span
              class="orange">【拒绝】</span>，当选择<span
              class="orange">【拒绝】</span>必须填写拒绝的理由
          </p>
        </div>
        <img src="../../../assets/userImg/applicationPhone.png" alt="">
      </div>
    </el-tab-pane>
  </el-tabs>

</template>

<script>
export default {
  name: "editApplication",
  data() {
    return {activeName:'first'}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
